export function dig(object, array) {
  return array.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), object);
}
